export var DisabledUI;
(function (DisabledUI) {
    DisabledUI["FromAmount"] = "fromAmount";
    DisabledUI["FromToken"] = "fromToken";
    DisabledUI["ToAddress"] = "toAddress";
    DisabledUI["ToToken"] = "toToken";
})(DisabledUI || (DisabledUI = {}));
export var HiddenUI;
(function (HiddenUI) {
    HiddenUI["Appearance"] = "appearance";
    HiddenUI["DrawerCloseButton"] = "drawerCloseButton";
    HiddenUI["History"] = "history";
    HiddenUI["Language"] = "language";
    HiddenUI["PoweredBy"] = "poweredBy";
    HiddenUI["ToAddress"] = "toAddress";
    HiddenUI["ToToken"] = "toToken";
    HiddenUI["WalletMenu"] = "walletMenu";
    HiddenUI["IntegratorStepDetails"] = "integratorStepDetails";
    HiddenUI["ReverseTokensButton"] = "reverseTokensButton";
    HiddenUI["RouteTokenDescription"] = "routeTokenDescription";
    HiddenUI["ChainSelect"] = "chainSelect";
    HiddenUI["BridgesSettings"] = "bridgesSettings";
    HiddenUI["AddressBookConnectedWallets"] = "addressBookConnectedWallets";
    HiddenUI["LowAddressActivityConfirmation"] = "lowAddressActivityConfirmation";
    HiddenUI["GasRefuelMessage"] = "gasRefuelMessage";
    HiddenUI["SearchTokenInput"] = "searchTokenInput";
    HiddenUI["InsufficientGasMessage"] = "insufficientGasMessage";
})(HiddenUI || (HiddenUI = {}));
export var RequiredUI;
(function (RequiredUI) {
    RequiredUI["ToAddress"] = "toAddress";
    RequiredUI["AccountDeployedMessage"] = "accountDeployedMessage";
})(RequiredUI || (RequiredUI = {}));
export var ExpansionType;
(function (ExpansionType) {
    ExpansionType["Routes"] = "routes";
    ExpansionType["FromChain"] = "fromChain";
    ExpansionType["ToChain"] = "toChain";
})(ExpansionType || (ExpansionType = {}));
//# sourceMappingURL=widget.js.map